/* eslint-disable no-useless-catch */
import { serialize } from 'utils/crud';

import { FindOneOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-report';

export const EntityReportApi = {
  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  filter: async (option: FindOneOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string | undefined) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface EntityReportQuery {
  targetType?: number;
  order?: any;
  page?: number;
  take?: number;
  skip?: number;
  tab?: string;
  reserved?: boolean;
}
